import classNames         from 'classnames';
import * as PropTypes     from 'prop-types';
import * as React         from 'react';
import { useTranslation } from 'react-i18next';
import { Link }           from 'react-router-dom';

import { OffersSlider, Price } from '../../../new-components';

const SearchDoorItem = function(props) {
  const { t } = useTranslation();

  const { offers } = props;

  const current = Object.values(offers)[0];

  const {
          common: {
                    constructionTypeId,
                    discountPrice,
                    isExpressMarker,
                    isInterior,
                    isMarker,
                    isSpecMarker,
                    label,
                    price,
                    showDiscountPrice,
                    urlKey,
                    vendorCode,
                  },
        } = current;

  return (
    <Link
      className={
        classNames('item card inline ', {
          'double':   constructionTypeId === 2,
          'interior': isInterior,
        })
      }
      to={urlKey}
    >
      <div className={'picture'}>
        <OffersSlider
          current={+Object.keys(offers)[0]}
          inline
          offers={offers}
          showOffers
        />
      </div>
      <div>
        <div className={'title'}>
          {label}
        </div>
        <div className={'sku'}>
          {t('client_vendorCode')}: {vendorCode}
        </div>
        {!isInterior && (
          <Price
            discountPrice={discountPrice}
            isExpressMarker={isExpressMarker}
            isMarker={isMarker}
            isSpecMarker={isSpecMarker}
            price={price}
            showDiscountPrice={showDiscountPrice}
          />
        )}
      </div>
    </Link>
  );

};

SearchDoorItem.propTypes = {
  offers: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
};

export default SearchDoorItem;
